const codeContainer = '#CTYHOCN-code'
const corpCodeContainer = '#corporate-code'
const $errorBoxShow = $('#error-messages')
let localData

// Default links, these will be overwritten when a hotel code (CTYHOCN) is chosen
let DBLinks = {
  homeUrl: 'javascript:void(0)',
  directionsUrl: 'javascript:void(0)',
  amenitiesUrl: 'javascript:void(0)'
}

function getFileRootName (str) {
  const parts = str.split('-')
  return parts.length > 2 ? parts.slice(0, -2).join('-') : str
}

function setImageLibrarySelection (hotelType, imageRootName) {
  $(`.image-library .${hotelType}-selection .image-container`).removeClass('selected')
  $(`.image-library .${hotelType}-selection .image-container img[data-filename^="${imageRootName}"]`)
    .parent().addClass('selected')
}

function updateImageLibrary () {
  if (localData.headerImage === 'corporate-image') {
    $('.image-library .library-selection.dynamic-selection').removeClass('hidden')
    $('.image-library .library-selection.static-selection').addClass('hidden')
  } else {
    $('.image-library .library-selection.dynamic-selection').addClass('hidden')
    $('.image-library .library-selection.static-selection').removeClass('hidden')
  }
}

function limitTextLinkChoice () {
  // Limit users to having 2 checkboxes enabled at any one time
  // Make sure selected checkboxes are enabled
  $(".checkbox-list input[type='checkbox']:checked").each(function () {
    setLinkItemInteractivity($(this), true)
  })
  // Toggle the other checkboxes appropriately
  const maxCheckedAtOnce = 1
  const enable = $('.checkbox-list input:checked').length < maxCheckedAtOnce
  $(".checkbox-list input[type='checkbox']:not(:checked)").each(function () {
    setLinkItemInteractivity($(this), enable)
  })
}

function setLinkItemInteractivity ($checkbox, enable) {
  // Enable or disable link item
  const disable = !enable
  $checkbox.parents('label').toggleClass('disabled-text', disable)
  $checkbox.prop('disabled', disable)
  // Check if there are buttons associated with the checkbox and enable/disable as needed
  const $buttons = $checkbox.parent().find('.btn')
  if ($buttons.length) {
    $buttons.each(function () {
      const $button = $(this)
      $button.prop('disabled', disable)
      $button.find('input').prop('disabled', disable)
      $button.toggleClass('disabled', disable)
    })
  }
}

function getTextFromHtml (selector) {
  // Get html, encodes the value and removes html tags
  return $('<div />').html((selector.val()).replace(/(<([^>]+)>)/ig, '')).text()
}

function validateBuilder () {
  const multiHotel = $('#multi-hotel').val()
  const errors = []

  if (multiHotel === 'single') {
    const cityCode = $('#CTYHOCN-code').val()
    if (cityCode === '' || cityCode === i18next.t('builder_ctyhocn_placeholder')) {
      errors.push(i18next.t('builder_error_ctyhocn'))
    }
  }

  const corporateCode = $('#corporate-code').val()
  if (corporateCode === '') {
    errors.push(i18next.t('builder_error_group_code'))
  }

  const $customMessage = $('#custom-message')
  const customCharLimit = 1500
  if (getTextFromHtml($customMessage).length > customCharLimit) {
    errors.push(i18next.t('builder_error_custom_message_chars', { customCharLimit }))
  }

  const $additionalInfoMessage = $('#additional-info')
  if (getTextFromHtml($additionalInfoMessage).length > customCharLimit) {
    errors.push(i18next.t('builder_error_additional_info_chars', { customCharLimit }))
  }

  if (multiHotel === 'single') {
    const $checkboxes = $('.checkbox-list input:checked')
    const checkBoxTotal = 1
    if ($checkboxes.length !== checkBoxTotal) {
      errors.push(i18next.t('builder_error_text_links', { textLinksRequired: checkBoxTotal }))
    }
  }

  return errors
}

function builderAjax () {
  $('#email-details').ajaxForm({
    beforeSerialize: function () {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', true)
      $submitBtn.addClass('loading')
      const errors = validateBuilder()
      const $errorBox = $('#error-messages')
      if (errors.length === 0) {
        $errorBox.hide()
        return true
      }

      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      $errorBox.text(errors.join('\n'))
      $errorBox.slideDown()

      return false
    },
    url: '/builder/save',
    cache: false,
    dataType: 'text',
    success: function (data) {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      let errorText = ''
      const $errorBox = $('#error-messages')
      try {
        const response = JSON.parse(data)

        if (response.success) {
          window.location.href = '/emailer/' + response.emailId
          return
        }

        if (response.error) {
          errorText = response.error.replace(/,/g, '\n')
        }
      } catch (e) {
        errorText = 'An unexpected problem occurred'
      }
      $errorBox.text(errorText).slideDown()
    },
    error: function (jqXHR) {
      const $submitBtn = $('#email-details button[type="submit"]')
      $submitBtn.prop('disabled', false)
      $submitBtn.removeClass('loading')
      let errorText = jqXHR.responseText
      const $errorBox = $('#error-messages')
      try {
        const json = JSON.parse(errorText)
        if (json.error) {
          errorText = json.error.replace(/,/g, '\n')
        }
      } catch (e) {
        errorText = 'An unexpected problem occurred'
      }
      $errorBox.text(errorText).slideDown()
    }
  })
}

function initTooltips () {
  // Initialise tooltips
  $('[data-toggle="tooltip"]').tooltip()
}

function makeBannerLink (imgName) {
  let link = '/assets/v2/' + imgName + '.jpg'
  const lang = getLangCode()
  if (lang !== 'en') {
    link = '/assets/v2/' + imgName + '-' + lang + '.jpg'
  }
  return link
}

function makeHotelLink () {
  const link = {
    id: 'hotel-details',
    title: i18next.t('email_hotel_details'),
    url: DBLinks.homeUrl
  }
  return link
}

function previewInit () {
  localData = {
    urlDomain: '',
    multiHotel: false,
    headerImage: 'corporate-image',
    banerImgLibStatic: 'default-image-1',
    banerImgLibDynamic: 'default-image-1',
    _id: '',
    hotelInfo: {
      usename: i18next.t('email_hotel_name_placeholder'),
      addr1: i18next.t('email_hotel_address_placeholder'),
      city: i18next.t('email_hotel_city_placeholder'),
      zip: i18next.t('email_hotel_zip_placeholder'),
      country: i18next.t('email_hotel_country_placeholder'),
      phone: i18next.t('email_hotel_phone_placeholder')
    },
    headerText: '',
    bookButton: {
      title: i18next.t('email_book_now'),
      url: bookingLinkMaker({
        cityCode: '',
        corporateCode: '',
        search: false
      })
    },
    mainText: '',
    links: [
      makeHotelLink(),
      {
        id: 'maps-directions'
      }
    ],
    inclusionList: '',
    extraList: '',
    banners: [
      {
        path: makeBannerLink('img-02'),
        link: i18next.t('link_hhonors')
      },
      {
        path: makeBannerLink('img-03'),
        link: i18next.t('link_explore')
      }
    ],
    termsConditions: '',
    language: getLangCode()
  }

  // Get template data and replace CKEditor if this is the correct page
  const $preview = $('.preview-container')
  if ($preview.length) {
    // Get templateId
    const templateId = $('#templateId').val()
    // Get and load template data
    getTemplateData(templateId, function () {
      ckEditorInit()
    })
  }

  setImageLibrarySelection('static', localData.banerImgLibStatic)
  setImageLibrarySelection('dynamic', localData.banerImgLibDynamic)
}

function reloadLink ($input) {
  const name = $input.attr('name')
  const title = $input.parent().text()
  const newLink = {
    id: name,
    title,
    url: generalLinkMaker(name)
  }
  // Add link
  localData.links.push(newLink)
}

function reloadLinks () {
  const multiHotel = $('#multi-hotel').val()
  // Remove links
  localData.links = []
  // Add hotel details link (if we are dealing with a single hotel)
  if (multiHotel === 'single') {
    localData.links.push(makeHotelLink())
  }
  // Reload Links
  $('.checkbox-list input[type=checkbox]:checked').each(function () {
    reloadLink($(this))
  })
  // Update booking link
  const cityCode = $(codeContainer).val()
  const corporateCode = $(corpCodeContainer).val()
  // Check if single or multi hotel
  let search = false
  if (multiHotel === 'multi') {
    search = true
  }
  localData.bookButton.url = bookingLinkMaker({
    cityCode,
    corporateCode,
    search
  })
}

function bookingLinkMaker (code) {
  const search = code.search
  const corporateCode = code.corporateCode
  let url

  // Booking Engine
  const lang = i18next.language
  const langCode = lang.substring(0, 2)

  let trackingCode = 'DCP'
  const rateType = $('#rateType').val()
  if (rateType === 'static-rate') {
    trackingCode = 'SCR'
  }

  let wtmcLang = langCode.toUpperCase()
  if (wtmcLang === 'EN') {
    wtmcLang = ''
  }
  const wtmc = '&WT.mc_id=zJNECAA0EA1CI2OLG4GWIZ' + trackingCode + wtmcLang + '087GW841651'

  const urlPart = 'corporateCode=' + corporateCode + wtmc

  // Construct UrL
  url = 'https://www.hilton.com/' + langCode.toLowerCase() + '/book/reservation/rooms/?ctyhocn=' + code.cityCode + '&' + urlPart

  if (search) {
    // Create a search link based on corp code
    url = 'http://www.hilton.com/' + langCode.toLowerCase() + '/search/find-hotels/?' + urlPart
  }

  return url
}

function generalLinkMaker (type) {
  if (type === 'maps-directions') {
    return DBLinks.directionsUrl
  } else if (type === 'amenities-services') {
    return DBLinks.amenitiesUrl
  }
}

function reloadInclusionsAndExtras () {
  const $inclusions = $('.inclusions-list input[type="checkbox"]:checked')
  localData.inclusionList = getCheckboxArray($inclusions)

  const $extras = $('.extra-list input[type="checkbox"]:checked')
  localData.extraList = getCheckboxArray($extras)
}

function getCheckboxArray ($checkboxList) {
  const list = []
  $checkboxList.each(function () {
    const obj = {
      id: $(this).attr('name'),
      text: $.trim($(this).parent().text())
    }
    list.push(obj)
  })
  return list
}

function reloadTemplate (data) {
  const $preview = $('.preview-container')
  // Reload templates just if preview-container class exists
  if ($preview.length) {
    // Get html from the template
    const html = window.app.templates.email_preview(data)
    // Show the preview email
    $preview.empty().append(html)
  }
}

function textareaUpdate (editor, textBlockField, textBlockId, dataName) {
  localData[dataName] = editor.getData()
  // Update text box in builder panel
  $('#' + textBlockField).val(localData[dataName])
  // Update email preview
  const $textBlock = $('#' + textBlockId)
  if ($textBlock.length && localData[dataName] !== '') {
    // If the text block exists and there is data then update it.
    $textBlock.html(localData[dataName])
  } else {
    // If it doesn't exist or there is no data re-render the template.
    // This is because the block has padding and we don't want to render it if there is no data
    // We also don't want to render the template on every keypress as this causes performance issues on IE
    reloadTemplate(localData)
  }
}

function checkCheckboxes (arrayToCheck) {
  $.each(arrayToCheck, function (index, value) {
    $('#' + value.id).prop('checked', true)
  })
}

function setHeaderImage () {
  const rateType = $('#rateType').val()
  localData.headerImage = 'static-image'
  if (rateType !== 'static-rate') {
    localData.headerImage = 'corporate-image'
  }
}

function populateForm (data) {
  $('#CTYHOCN-code').val(data.ctyhocn)
  $('#corporate-code').val(data.corporateCode)
  $('#header-message').val(data.headerText)
  $('#custom-message').val(data.mainText)
  $('#header-image-static').val(data.banerImgLibStatic)
  setImageLibrarySelection('static', data.banerImgLibStatic)
  $('#header-image-dynamic').val(data.banerImgLibDynamic)
  setImageLibrarySelection('dynamic', data.banerImgLibDynamic)
  $(".checkbox-list input[type='checkbox']").prop('checked', false)
  checkCheckboxes(data.extraList)
  checkCheckboxes(data.inclusionList)
  checkCheckboxes(data.links)
  $('#maps-directions').change()
  $('#additional-info').val(data.termsConditions)
  let multiHotel = 'single'
  if (data.multiHotel === true) {
    multiHotel = 'multi'
  }
  $('#multi-hotel').val(multiHotel).change()
  updateImageLibrary()
}

function getTemplateData (id, callback) {
  if (id) {
    $.ajax({
      url: '/getTemplateData/' + id,
      method: 'GET',
      async: true,
      cache: false,
      contentType: false,
      processData: false
    })
      .done(function (data) {
        if (data) {
          // Override the default data
          localData = data
          const dl = data.links
          for (let i = 0; i < dl.length; i++) {
            if (dl[i].id === 'hotel-details') {
              DBLinks.homeUrl = dl[i].url
              makeHotelLink()
            } else if (dl[i].id === 'maps-directions') {
              DBLinks.directionsUrl = dl[i].url
            } else if (dl[i].id === 'amenities-services') {
              DBLinks.amenitiesUrl = dl[i].url
            }
          }
          populateForm(data)
        }
      })
      .fail(function (err) {
        $errorBoxShow.html(err).slideDown()
      })
      .always(function () {
        // When the page load, render the template with the default data or the real data
        reloadTemplate(localData)
        // Continue ckEditor Init
        callback()
      })
  } else {
    // Set header image
    setHeaderImage()
    // Set defaults
    populateForm(localData)
    // Reload Links
    reloadLinks()
    // When the page load, render the template with the default data
    reloadTemplate(localData)
    // Continue ckEditor Init
    callback()
  }
}

function checkLimits (obj) {
  if (obj.data.keyCode === 8 || obj.data.keyCode === 46) {
    return true
  }
  if (obj.editor.document.getBody().getText().length >= obj.editor.config.maxLength) {
    obj.data.domEvent.preventDefault()
  }
}

function ckEditorInit () {
  // TextAreas
  const headerMessageField = 'header-message'
  const customMessageField = 'custom-message'
  const additionalInfoField = 'additional-info'

  // Maximum characters
  const maxCustomTerms = 1500

  // General options for editors config
  const mainConfig = {
    extraPlugins: 'charcount',
    removePlugins: 'colorbutton',
    allowedContent: 'h1 h2 h3 p ul li b i; a[!href,alt];',
    language: i18next.language
  }

  // Specific options for editors config
  const headerConfig = $.extend({}, mainConfig)
  headerConfig.removePlugins = mainConfig.removePlugins + ',basicstyles,link,toolbar'

  const customConfig = $.extend({}, mainConfig)
  customConfig.maxLength = maxCustomTerms
  customConfig.extraPlugins = mainConfig.extraPlugins + ',list'

  const additionalInfoConfig = $.extend({}, mainConfig)
  additionalInfoConfig.maxLength = maxCustomTerms

  // Replace CKEditor on header message, custom message and additional info textareas
  const headerEditor = window.CKEDITOR.replace(headerMessageField, headerConfig)
  const customEditor = window.CKEDITOR.replace(customMessageField, customConfig)
  const additionalInfoEditor = window.CKEDITOR.replace(additionalInfoField, additionalInfoConfig)

  // Disable non-breaking space entity
  window.CKEDITOR.config.fillEmptyBlocks = false

  // Check limits for header message editor
  headerEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  // Check limits for custom message editor
  customEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  // Check limits for additional info editor
  additionalInfoEditor.on('key', function (obj) {
    checkLimits(obj)
  })

  headerEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_header_corporate_text'))
      localData.headerText = this.getData()
      reloadTemplate(localData)
    }
  })

  customEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_main_corporate_text'))
      localData.mainText = this.getData()
      reloadTemplate(localData)
    }
  })

  additionalInfoEditor.on('instanceReady', function () {
    if (!this.getData()) {
      this.setData(i18next.t('email_additional_info'))
      localData.termsConditions = this.getData()
      reloadTemplate(localData)
    }
  })

  headerEditor.on('change', function () {
    textareaUpdate(headerEditor, headerMessageField, 'header-text-block', 'headerText')
  })

  customEditor.on('change', function () {
    textareaUpdate(customEditor, customMessageField, 'main-text-block', 'mainText')
  })

  additionalInfoEditor.on('change', function () {
    textareaUpdate(additionalInfoEditor, additionalInfoField, 'additional-info-block', 'termsConditions')
  })
}

function convertToSingleHotel () {
  // Show any fields that are intended to be shown on single hotels only
  $('.single-hotel-field').show()
  // Set placeholder text in CKEditor
  if (window.CKEDITOR.instances['custom-message']) {
    const rateType = $('#rateType').val()
    if (rateType === 'static-rate') {
      window.CKEDITOR.instances['custom-message'].setData(i18next.t('email_main_static_text'))
    } else {
      window.CKEDITOR.instances['custom-message'].setData(i18next.t('email_main_corporate_text'))
    }
  }
  // Unhide hotel address
  localData.hotelInfo.hide = false
  // Recheck link limits (different limits on single and multi hotel)
  limitTextLinkChoice()
  // Trigger change on CTYHOCN to repopulate placeholder address on email template
  $('#CTYHOCN-code').change()
  reloadLinks()
  reloadTemplate(localData)
}

function convertToMultiHotel () {
  // Hide any fields that are intended to be shown on single hotels only
  $('.single-hotel-field').hide()
  // Set placeholder text in CKEditor
  if (window.CKEDITOR.instances['custom-message']) {
    const rateType = $('#rateType').val()
    if (rateType === 'static-rate') {
      window.CKEDITOR.instances['custom-message'].setData(i18next.t('email_main_expanded_static_text'))
    } else {
      window.CKEDITOR.instances['custom-message'].setData(i18next.t('email_main_expanded_corporate_text'))
    }
  }
  // Hide address and reset to default values
  localData.hotelInfo = {
    hide: true,
    usename: i18next.t('email_hotel_name_placeholder'),
    addr1: i18next.t('email_hotel_address_placeholder'),
    city: i18next.t('email_hotel_city_placeholder'),
    zip: i18next.t('email_hotel_zip_placeholder'),
    country: i18next.t('email_hotel_country_placeholder'),
    phone: i18next.t('email_hotel_phone_placeholder')
  }
  // Reset link checkboxes to defaults and recheck link limits
  $('#maps-directions').prop('checked', false)
  $('#amenities-services').prop('checked', false)
  limitTextLinkChoice()
  // Uncheck all inclusions and extras and then hide
  $('.custom-message-links').find('input').prop('checked', false)
  $('.custom-message-links input[type="checkbox"]').change()
  // Clear the CTYHOCN input and trigger change to update links etc
  $('#CTYHOCN-code').val(i18next.t('builder_ctyhocn_placeholder')).change()
  reloadLinks()
  reloadTemplate(localData)
}

function initInputListeners () {
  // Update hotel data
  $(document).on('change', '#CTYHOCN-code', function () {
    const code = $(this).val()
    $.ajax({
      url: '/getHotelInfo/' + code,
      type: 'GET',
      async: true,
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        if (data) {
          localData.hotelInfo = {
            usename: data.innName,
            addr1: data.addrLine1,
            city: data.addrCity,
            zip: data.zipCode,
            country: data.country,
            phone: data.phone
          }
          DBLinks = {
            homeUrl: data.homeUrl,
            directionsUrl: data.directionsUrl,
            amenitiesUrl: data.amenitiesUrl
          }
          reloadLinks()
          reloadTemplate(localData)
        }
      }
    })
  })

  // Trigger limitTextLinkChoice when ever a checkbox is checked or unchecked
  $(document).on('change', '.checkbox-list input[type="checkbox"]', limitTextLinkChoice)

  $(document).on('change', '#multi-hotel', function (e) {
    if (e.target.value === 'single') {
      return convertToSingleHotel()
    }
    return convertToMultiHotel()
  })

  $(document).on('keyup', '#corporate-code', function () {
    // Reload links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '.checkbox-list input[type="checkbox"]', function () {
    // Reload Links
    reloadLinks()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('change', '.custom-message-links input[type="checkbox"]', function () {
    // Reload Inclusions and Extras
    reloadInclusionsAndExtras()
    // Reload template
    reloadTemplate(localData)
  })

  $(document).on('click', '#header-image-library-btn', function () {
    $('#imageLibraryModal').modal('show')
  })

  $(document).on('click', '.image-library .image-container', function () {
    $(this).siblings().removeClass('selected')
    $(this).addClass('selected')
  })

  $(document).on('click', '#btn-close-image-library', function () {
    $('#imageLibraryModal').modal('hide')
  })

  $(document).on('click', '#btn-save-image-library', function () {
    // Save Value
    const filenameStatic = $('.image-library .static-selection .image-container.selected img').data('filename')
    const filenameDynamic = $('.image-library .dynamic-selection .image-container.selected img').data('filename')

    $('#header-image-static').val(getFileRootName(filenameStatic)).change()
    $('#header-image-dynamic').val(getFileRootName(filenameDynamic)).change()

    $('#imageLibraryModal').modal('hide')
  })

  $(document).on('change', '#header-image-static', function () {
    const imageRootName = $(this).val()
    localData.banerImgLibStatic = imageRootName
    setImageLibrarySelection('static', imageRootName)
    reloadTemplate(localData)
  })

  $(document).on('change', '#header-image-dynamic', function () {
    const imageRootName = $(this).val()
    localData.banerImgLibDynamic = imageRootName
    setImageLibrarySelection('dynamic', imageRootName)
    reloadTemplate(localData)
  })

  // Prevent clicks on preview
  $(document).on('click', '.booking-builder.preview-container', function (e) {
    e.preventDefault()
  })
}

// eslint-disable-next-line no-unused-vars
function builderInit () {
  previewInit()
  initTooltips()
  builderAjax()
  initInputListeners()
  limitTextLinkChoice()
  updateImageLibrary()
}
